var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-ring",style:({ width: _vm.addUnit(_vm.ringSize), height: _vm.addUnit(_vm.ringSize) })},[_c('div',{staticClass:"n-ring__gradient",class:_vm.animation ? 'infiniteAnimation' : 'animation',style:(Object.assign({}, _vm.roundStyle))},[(_vm.arc)?_vm._l((_vm.pointListStyle),function(item,index){return _c('div',{key:index,staticClass:"n-ring__point",style:({
          transform: item.transform,
        })},[_c('div',{style:({
            width: (((_vm.ringWidth / 1920) * 100) + "vw"),
            height: (((_vm.ringWidth / 1920) * 100) + "vw"),
            background: item.color || _vm.defColorList[index],
          })})])}):_vm._e()],2),_c('div',{staticClass:"n-ring__gap",style:({
      backgroundColor: _vm.backgroundColor,
      width: ("calc(" + (_vm.addUnit(_vm.ringSize)) + " - " + (((_vm.ringWidth * 2) / 1920) * 100) + "vw)"),
      height: ("calc(" + (_vm.addUnit(_vm.ringSize)) + " - " + (((_vm.ringWidth * 2) / 1920) * 100) + "vw)"),
      padding: (((_vm.gapContent / 1080) * 100) + "vh"),
    })},[_c('div',{staticClass:"n-ring__gap__wrapper"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }